const iotmgtRouter = [
  {
    path: '/iotmgt/productManage/list',
    component: () => import('@/views/iotmgt/productManage/list'),
    name: 'iotProductManageList'
  },
  {
    path: '/iotmgt/deviceFirmwareManage/list',
    component: () => import('@/views/iotmgt/deviceFirmwareManage/list'),
    name: 'iotmgtfirmwareManagelist'
  },
  {
    path: '/iotmgt/deviceVendorFirmwareManage/list',
    component: () => import('@/views/iotmgt/deviceVendorFirmwareManage/list'),
    name: 'vendorFirmwareManageList'
  },
  {
    path: '/iotmgt/deviceManage/list',
    component: () => import('@/views/iotmgt/deviceManage/list'),
    name: 'iotmgtdeviceManagelist'
  },
  {
    path: '/iotmgt/deviceConfig/list',
    component: () => import('@/views/iotmgt/deviceConfig/list'),
    name: 'iotmgtdeviceConfiglist'
  },
  {
    path: '/iotmgt/inspectRecord/list',
    component: () => import('@/views/iotmgt/inspectRecord/list'),
    name: 'iotmgtinspectRecordlist'
  },
  {
    path: '/iotmgt/deviceConfig/version',
    component: () => import('@/views/iotmgt/deviceConfig/version'),
    name: 'iotmgtdeviceConfigVersionlist'
  },
  {
    path: '/iotmgt/productResource/list',
    component: () => import('@/views/iotmgt/productResourceManage/list'),
    name: 'productResourceManage'
  },

]
export default iotmgtRouter;
